module.exports = __webpack_public_path__ + "static/profile-9051e24b92602455d8b19ebb36efa7ca.png";